<div *ngIf="authenticating; else error" class="auth-container">
    <h5>Authenticating...</h5>
</div>
<ng-template #error>
    <div class="auth-container">
        <h5>Access denied.</h5>
    </div>
</ng-template>